import React from 'react';
import PropTypes from 'prop-types';

const DuplicateIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14">
        <g>
            <path d="M12.444 5.056v7a.39.39 0 01-.389.389h-7a.39.39 0 01-.389-.389v-7a.389.389 0 01.389-.389h7a.389.389 0 01.389.389m-.389-1.944A1.947 1.947 0 0114 5.056v7A1.946 1.946 0 0112.056 14h-7a1.947 1.947 0 01-1.944-1.944v-7a1.947 1.947 0 011.944-1.945h7zM10.111 0a.778.778 0 010 1.556H1.556v8.556a.778.778 0 01-1.556 0V1.944A1.944 1.944 0 011.944 0z" fill={fill} fillRule="evenodd" />
        </g>
    </svg>
);

DuplicateIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

DuplicateIcon.defaultProps = {
    width: '14',
    height: '14',
    fill: '#4b254e'
};

export default DuplicateIcon;
